import { useEffect, useState } from 'react'
import Checkbox from 'components/shared/Checkbox'

interface ServiceTermProps {
    onChange: (checked: boolean) => void
}

export const ServiceTerm = ({ onChange }: ServiceTermProps) => {
    const [allChecked, setAllChecked] = useState(false)
    const [checked, setChecked] = useState({
        service: false,
        privacy: false,
        seller: false,
    })

    const updateAllChecked = (next: boolean) => {
        setChecked({
            service: next,
            privacy: next,
            seller: next,
        })
        setAllChecked(next)
    }

    const updateOneChecked = (key: keyof typeof checked, value: boolean) => {
        const next = { ...checked, [key]: value }
        setChecked(next)
        const all = Object.values(next).every(Boolean)
        setAllChecked(all)
    }

    useEffect(() => {
        onChange(allChecked)
    }, [allChecked])

    return (
        <article className="flex flex-col gap-1 w-full">
            {/* 전체 동의 */}
            <div className="flex flex-row items-center py-2">
                <label htmlFor="checkbox-all" className="flex items-center cursor-pointer">
                    <Checkbox
                        id="checkbox-all"
                        checked={allChecked}
                        onChange={(e) => updateAllChecked(e.target.checked)}
                        className="p-2 m-1"
                    />
                    <p className="text-[clamp(14px,3vw,18px)] font-bold text-[#565656]">
                        전체 약관에 동의합니다 <span className="text-accect">*</span>
                    </p>
                </label>
            </div>
            <div className="w-full h-[1px] bg-[#f2f2f2]" />
            {/* 개별 동의 */}
            {[
                {
                    key: 'service',
                    label: '서비스 이용약관 (필수)',
                    url: 'https://queenlive.notion.site/647bef94f5d442088859646ced6250bd',
                },
                {
                    key: 'privacy',
                    label: '개인정보 처리방침 (필수)',
                    url: 'https://www.notion.so/a54fd209afba45328f52c072d8eb15a2',
                },
                {
                    key: 'seller',
                    label: '판매자 이용약관 (필수)',
                    url: 'https://www.notion.so/714bd14257e04cb2a4b510ccc696c64d',
                },
            ].map(({ key, label, url }) => {
                const checkboxId = `checkbox-${key}`
                return (
                    <div key={key} className="flex flex-row items-center py-2">
                        <label
                            htmlFor={checkboxId}
                            className="flex items-center flex-1 cursor-pointer"
                        >
                            <Checkbox
                                id={checkboxId}
                                checked={checked[key as keyof typeof checked]}
                                onChange={(e) =>
                                    updateOneChecked(key as keyof typeof checked, e.target.checked)
                                }
                                className="p-2 m-1"
                            />
                            <p className="text-[clamp(14px,3vw,18px)] text-[#565656]">{label}</p>
                        </label>
                        <a
                            href={url}
                            className="text-[clamp(14px,3vw,18px)] text-[#B1B1B1] underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            보기
                        </a>
                    </div>
                )
            })}
        </article>
    )
}
